import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyD6ghGXwP7WtEHJY3sahgFbgJWGSIpo8dI",
  authDomain: "dopravabrno-1.firebaseapp.com",
  projectId: "dopravabrno-1",
  storageBucket: "dopravabrno-1.appspot.com",
  messagingSenderId: "484792631981",
  appId: "1:484792631981:web:04b7c26e0c4dc347a7fc24",
  measurementId: "G-FT07486NC8",
};

const app = initializeApp(firebaseConfig);
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LemdfElAAAAAHIoHgfjWuQ_SwUio7dmGvT05xl_"),
  isTokenAutoRefreshEnabled: true,
});

const analytics = getAnalytics(app);
const functions = getFunctions(app, "europe-west1");

export const db = getFirestore(app);
export const handleFormSubmitFunction = httpsCallable(
  functions,
  "handleFormSubmit"
);
